import type { PanInfo } from 'framer-motion'

import type { ToastDirection } from '../types'

type MotionVariants = {
  initial: Record<string, unknown>
  animate: Record<string, unknown>
  exit: Record<string, unknown>
}

export const toastDirections: Record<ToastDirection, MotionVariants> = {
  right: {
    initial: { x: '100%' },
    animate: { x: '0%' },
    exit: { x: '100%' },
  },
  left: {
    initial: { x: '-100%' },
    animate: { x: '0%' },
    exit: { x: '-100%' },
  },
  top: {
    initial: { y: '-100%' },
    animate: { y: '0%' },
    exit: { y: '-100%' },
  },
  bottom: {
    initial: { y: '100%' },
    animate: { y: '0%' },
    exit: { y: '100%' },
  },
}

export const dragAxisByDirection: Record<ToastDirection, 'x' | 'y'> = {
  right: 'x',
  left: 'x',
  top: 'y',
  bottom: 'y',
}

export const dragConstraintsByDirection: Record<
  ToastDirection,
  Record<string, number>
> = {
  right: { left: 0, right: 0 },
  left: { left: 0, right: 0 },
  top: { top: 0, bottom: 0 },
  bottom: { top: 0, bottom: 0 },
}

export const dragElasticByDirection: Record<
  ToastDirection,
  Record<string, number>
> = {
  right: { left: 0, right: 0.9 },
  left: { left: 0.9, right: 0 },
  top: { top: 0.9, bottom: 0 },
  bottom: { top: 0, bottom: 0.9 },
}

export const shouldDismissByDirection = (
  direction: ToastDirection,
  info: PanInfo,
  dismissDragOffset: number,
): boolean => {
  if (direction === 'right') return info.offset.x > dismissDragOffset
  if (direction === 'left') return info.offset.x < -dismissDragOffset
  if (direction === 'top') return info.offset.y < -dismissDragOffset
  return info.offset.y > dismissDragOffset
}
